<template lang="pug">
	.monitoring-log(v-if="showed")
		.card
			.card-header
				i.fa.fa-edit
				span Monitoring log
			.card-body.collapse.show
				.logs(v-show="channel && messages.length > 0")
					.text(v-for="message in messages")
						.log.success(v-if="('command' in message)" v-html="message.command")
						.log(v-if="('out' in message)" v-html="message.out")
						.log.danger(v-if="('err' in message)" v-html="message.err")
						.log(v-if="('end' in message)") Completed. Code: {{message.end}}
						.log.primary(v-if="('done' in message)") Done.
					.text.icon.fa.fa-spinner.fa-spin(v-if="state === 'waiting'")
			.card-body.collapse.show
				.form-horizontal
					.form-actions
						button.btn.btn-primary(type="submit" v-on:click="clear()")
							i.fa.fa-trash
							| &nbsp;&nbsp;Clear
						button.btn.btn-dark(type="button" v-on:click="close()") Close
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Monitoring } 		from './../../services/Monitoring'

	export default {
		name: "MonitoringLog",
		mixins: [Screen],
		screen: {
			events: {
				"Show MonitoringLog": function(channel_name) {

					console.log('Show MonitoringLog', channel_name);

					this.channel = channel_name;

					this.showed = true;

				},
				"Monitoring Channel Updated": function(channel_name, state, messages) {

					console.log('Monitoring Channel Updated', channel_name, state, messages);

					if (channel_name === this.channel) {

						this.state = state;
						this.messages = messages;

					}

					this.update();

				}
			}
		},
		data() {

			this.Monitoring = Monitoring;

			this.state = 'done';
			this.messages = [];

			return {
				showed: false,
				channel: null
			};

		},
		computed: {
		},
		methods: {
			collectData() {


			},
			clear() {

				Monitoring.clearChannel(this.channel);

			},
			close() {

				if (this.state === 'done') Monitoring.clearChannel(this.channel);

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.monitoring-log
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 80%
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 650px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

			.logs
				height: 500px
				overflow-y: auto
				font-size: 0.7rem

				.log

					&.success
						color: #4dbd74

					&.danger
						color: #f86c6b

					&.primary
						color: #20a8d8

</style>

